import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../redux/axiosBaseQuery";
import { baseApi } from "../../redux/baseAPI";
import axios from "axios";
import { cloneDeep } from "lodash";
import { getBaseUrl } from "redux/utils";

export const medicationApi = baseApi.injectEndpoints({
  tagTypes: ["Medication","FavMedication","GDRMedication"],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => {
        return {
          url: `/providers.json`,
          method: "GET",
          params: params
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    // Get Medications (Pending, Active, Inactive Medications)
    getMedications: builder.query({
      query: (data) => {
        if (data.pid){

          let params = { pid: data.pid,include_all_tabs_data: 1 , only_interactions: data?.only_interactions, };
          if (data?.drug_type == "supplements"){
            params.drug_type = "supplement";
          }

          return {
            url: `/prescriptions/get_medicines.json`,
            method: "GET",
            params: params,
          };
        }
      },
      // providesTags: (result) =>
      //   result
      //     ? [
      //       ...result.response.data.map(({ id }) => ({ type: 'Medication', id })),
      //       { type: 'Medication', id: 'LIST' },
      //     ]
      //     : [{ type: 'Medication', id: 'LIST' }],
      providesTags: ["Medication"],
    }),
    getFavMedications: builder.query({
      query: (patientId) => {
        return {
          url: `/prescriptions/get_favorites.json`,
          method: "GET",
          params: { pid: patientId },
        };
      },
      providesTags: ["FavMedication"],
    }),
    medicationHistory: builder.query({
      query: (patientId) => {
        return {
          url: `/prescriptions/ds_get_surescripts_history.json`,
          method: "GET",
          params: { pid: patientId },
        };
      },
      // preferCacheValue: false,
    }),
    medicationRefusal: builder.query({
      query: (patientId) => {
        return {
          url: `/refusals.json`,
          method: "GET",
          params: { pid: patientId, type: "medication" },
        };
      },
      providesTags: ["refusal"],
      // preferCacheValue: false,
    }),
    // Get Interaction Alerts.
    getInteractions: builder.query({
      query: (data) => {
        return {
          url: `/prescriptions/get_interactions.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["Interactions"],
    }),
    //Get Interactions on add/edit medication
    getInteractions: builder.query({
      query: (data) => {
        return {
          url: `/prescriptions/get_interactions.json`,
          method: "POST",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["Interactions"],
    }),

    // medical_codes categories
    getMedicalCodeCategory: builder.query({
      query: () => {
        return {
          url: `/medical_codes/categories.json`,
          method: "GET",
        };
      },
    }),

    // medical_codes cpt.json
    getMedicalByCategory: builder.query({
      query: (categoryId) => {
        return {
          url: `/medical_codes/cpt.json`,
          method: "GET",
          params: {
            category: categoryId,
            lower_case: 1,
          },
        };
      },
    }),

    // medical_codes cpt.json?

    // getMedicalWord: builder.query({
    //   query: (keyword) => {
    //     return {
    //       url: `/utilities/search_cpts.json`,
    //       method: "GET",
    //       params: {
    //         keyword: keyword,
    //         lower_case: 1
    //       },
    //     };
    //   },
    // }),

    // Get eRx Refill Requets.
    getMedicationRefillRequests: builder.query({
      query: (data) => {
        return {
          url: `/prescriptions/ds_get_medication_refill_requests.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["MedicationRefillRequests"],
    }),

    // Get eRx Refill Response.
    getMedicationRefillResponses: builder.query({
      query: (data) => {
        return {
          url: `/prescriptions/ds_get_medication_refill_responses.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["MedicationRefillResponses"],
    }),

    // Get eRx Change Requests.
    getMedicationChangeRequests: builder.query({
      query: (data) => {
        return {
          url: `/pharmacy/rx_change_request.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["MedicationChangeRequests"],
    }),

    // Get eRx Change Responses.
    getMedicationChangeResponses: builder.query({
      query: (data) => {
        return {
          url: `/pharmacy/rx_change_response.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["MedicationChangeResponses"],
    }),

    // Get Patient Payer Plan etc.
    getPatientPayerInfo: builder.query({
      query: (patientId) => {
        return {
          url: `/prescriptions/ds_get_payer_info.json`,
          method: "GET",
          params: { pid: patientId },
        };
      },
      transformResponse: (response, msg, arg) => response.response,
      providesTags: ["MedicationPayerInfo"],
    }),

    // Get Medication Coverage Details, payer Info, Copay, Alternatives etc.
    // getMedicationCoverageDetails: builder.query({
    //   // // Params will be
    //   //   drug_rcopia_id,
    //   //   pid,
    //   //   ds_patient_id,
    //   //   formulary,
    //   //   patient_eligibility_id,
    //   //   alternatives_id
    //   query: (data) => {
    //     return {
    //       url: `/prescriptions/ds_get_med_coverage_detailed.json`,
    //       method: "GET",
    //       params: { ...data },
    //     };
    //   },
    //   transformResponse: (response, meta, arg) => response.response.data,
    //   providesTags: ["MedicationCoverageDetail"],
    // }),

    // Search Medications from Dr. First
    findMedicine: builder.query({
      query: (medicine) => {
        let url = `/prescriptions/ds_search_medicine.json?keyword=${medicine?.query || medicine}`;
        if (medicine?.isDespensing) {
          url += `&is_dispensing_med=1`;
          if (medicine?.location_id) {
            url += `&location_id=${medicine.location_id}`;
          }
        }
        return {
          url,
          method: "GET",
        };
      },
    }),

    refusalSettings: builder.query({
      query: () => {
        return {
          url: `/refusals/settings.json`,
          method: "GET",
        };
      },
      // preferCacheValue: false,
    }),

    // Get Favorite Medications
    fetchFavorites: builder.query({
      query: (fav_type = "all", pid = "") => {
        return {
          url: `/prescriptions/get_favorites.json?fav_type=${fav_type}&pid=${pid}`,
          method: "GET",
        };
      },
      // preferCacheValue: false,
    }),

    // Get Favorite Medications
    getFavoritesMedicine: builder.query({
      query: (fav_type = "all", pid = "") => {
        return {
          url: `/prescriptions/get_favorites.json?fav_type=${fav_type}&pid=${pid}`,
          method: "GET",
        };
      },

      // preferCacheValue: false,
    }),
    // Get medication Strength/Dose
    fetchPatientAllergy: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/prescriptions/ds_patient_allergies.json?pid=${pid}`,
          method: "GET",
        };}
      },
      // preferCacheValue: false,
    }),

    fetchFrequentPharmacy: builder.query({
      query: () => {
        return {
          url: `/prescriptions/get_frequently_used_pharmacies.json.json`,
          method: "GET",
        };
      },
      // preferCacheValue: false,
    }),

    // fetchMedicineStrength: builder.mutation({
    //   query: (payload) => {
    //     debugger
    //     payload.medicine = encodeURIComponent(payload.medicine);
    //     return {
    //       url: `/prescriptions/ds_search_strength.json`,
    //       method: "POST",
    //       data: payload,
    //     };
    //   },
    // }),
    removeMedicine: builder.mutation({
      query: (payload) => {
        return {
          url: `/prescriptions/ds_delete_medication.json`,
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "Medication" }],
    }),
    removeMultiMedicine: builder.mutation({
      query: (payload) => {
        return {
          url: `/prescriptions/ds_delete_multi_meds.json`,
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "Medication" }],
    }),
    addRefusalMedication: builder.mutation({
      query: (payload) => {
        return {
          url: `/refusals/save.json`,
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: ["refusal"],

      // preferCacheValue: false,
    }),
    addBulkMedication: builder.mutation({
      query: (payload) => {
        if(payload?.meds?.length>0){
            payload?.meds?.filter((v)=>{
            if(v?.Supervisor){
              delete v?.Supervisor
            }
          })
        }
        return {
          url: `/prescriptions/order_multi_meds.json`,
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "Medication" }],
      // preferCacheValue: false,
    }),

    changePharmacy: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_change_med_pharmacy.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),

    addMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => {
        let newObj = cloneDeep(body) 
        if(newObj?.Supervisor){
          delete newObj?.Supervisor
        }
        if ( newObj?.ds_medication_status)
        delete newObj?.ds_medication_status
        return({
        url: `/prescriptions/ds_add_medication.json`,
        method: "POST",
        data: newObj,
        params: { pid: newObj.pid },
      })},
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: ["Medication" ],
    }),

    sendPrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_send_prescription.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    overridePrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/interactions/override.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),

    addPatientReportedMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_add_update_self_reported_medication.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    // delete mediacation
    deleteMedication: builder.mutation({
      query: (data) => ({
        url: `/prescriptions/ds_delete_medication.json`,
        method: "POST",
        data: data,
      }),
      invalidatesTags: ["Medication"],
    }),
    getIndexLog: builder.mutation({
      query: (data) => ({
        url: `/prescriptions/get_prescription_status_log.json`,
        method: "GET",
        params: { med_id: data.med_id, portal: "provider" },
      }),
    }),
    getIntervention: builder.mutation({
      query: (data) => ({
        url: `/intervention/education_by_medication.json`,
        method: "GET",
        params: { pid: data.pid, rxnorm_drugcode: data.rxnorm_drugcode },
      }),
    }),

    getUpdatePrescriber: builder.mutation({
      query: (data) => ({
        url: `/prescriptions/change_med_prescriber.json`,
        method: "POST",
        data: { med_id: data.med_id, provider_id: data.provider_id },
      }),
      invalidatesTags: [{ type: "Medication" }],
    }),


    sendPrintPrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_set_prescription_printed.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    deletePrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_delete_medication.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    epcPrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/get_epcs_agreement.json.json`,
        method: "POST",
        data: body,
        //params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    epcAgreementSave: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/save_epcs_agreement.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    checkDublicatePrescription: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/check_if_duplicate_exists.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
    }),

    fetchCategoryByWord: builder.query({
      query: (keyword) => {
        return {
          url: `/medical_codes/cpt.json`,
          method: "GET",
          params: {keyword:(typeof keyword != "object" ? keyword : ""),
            category:keyword.id,
            lower_case: 1,}
          
        };
      },
    }),
    activateMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_update_medication_status.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "Medication" }],
    }),
    delFavMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/del_favorite.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      invalidatesTags: [{ type: "FavMedication" }],
    }),
    erxProcessMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/pharmacy/reply_to_rx_change_request.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      // transformResponse: (response, meta, arg) => response.response.data.current,
      //invalidatesTags: [{ type: "Medication" }],
    }),
    getSurescriptsHistory: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/prescriptions/ds_get_surescripts_history.json`,
        method: "GET",
        params: { pid: body.pid },
      }),
      transformResponse: (response, meta, arg) => response,
      //invalidatesTags: [{ type: "Medication" }],
    }),
    calculateDoseMedication: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => {
        return {
          url: `/prescriptions/calculate_dose.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response,
      //invalidatesTags: [{ type: "Medication" }],
    }),
    deleteRefusalMed: builder.mutation({
      query: (body) => ({
        url: `/refusals/delete.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: [{ type: "Medication" }],
    }),
    activateBulkMed: builder.mutation({
      query: (body) => ({
        url: `/prescriptions/ds_activate_multi_meds.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: [{ type: "Medication" }],
    }),

    updateFavMedication:builder.mutation({
      query:(body)=>({
          url:"/prescriptions/update_favorite.json.json",
          method:"POST",
          data:body,
      }),
      invalidatesTags:["FavMedication"]
    }),
    getGdrMedication: builder.query({
      query: (patientId) => {
        return {
          url: `/prescriptions/get_gdr_meds.json`,
          method: "GET",
          params: { pid: patientId },
        };
      },
      providesTags: ["GDRMedication"],
    }),
    addToGDR:builder.mutation({
      query:(body)=>({
          url:"/prescriptions/add_to_gdr_meds.json",
          method:"POST",
          data:body,
      }),
      invalidatesTags:["GDRMedication"]
    }),
    saveGDR:builder.mutation({
      query:(body)=>({
          url:"/prescriptions/save_gdr_meds.json",
          method:"POST",
          data:body,
      }),
      invalidatesTags:["GDRMedication"]
    }),
    removeGDR:builder.mutation({
      query:(body)=>({
          url:"/prescriptions/remove_from_gdr_meds.json",
          method:"POST",
          data:body,
      }),
      invalidatesTags:["GDRMedication"]
    }),
    getAddHistoryData:builder.mutation({
      query:(body)=>({
          url:"/prescriptions/ds_medication_search_by_rxcui.json",
          method:"POST",
          params:body,
      }),
      //invalidatesTags:["GDRMedication"]
    }),
    getPrescriberDetailForPatient:builder.query({
      query:(body)=>({
        url:"/users/get_prescriber_detail_for_patient.json",
        method:"GET",
        params:body,
      }),
    }),
  }),
});

export const {
  useGetUsersQurey,
  useGetMedicationsQuery,
  useGetFavMedicationsQuery,
  useGetInteractionsQuery,
  useGetMedicalCodeCategoryQuery,
  useGetMedicalByCategoryQuery,
  useGetMedicationRefillRequestsQuery,
  useGetMedicationRefillResponsesQuery,
  useGetMedicationChangeRequestsQuery,
  useGetMedicationChangeResponsesQuery,
  useGetPatientPayerInfoQuery,
  useGetMedicationCoverageDetailsQuery,
  useFindMedicineQuery,

  //useFetchMedicineStrengthMutation,
  useFetchFavoritesQuery,
  useAddMedicationMutation,
  useFetchFrequentPharmacyQuery,
  useAddPatientReportedMedicationMutation,
  useAddBulkMedicationMutation,
  useFetchPatientAllergyQuery,
  useRefusalSettingsQuery,
  useMedicationRefusalQuery,
  useMedicationHistoryQuery,
  useAddRefusalMedicationMutation,
  useRemoveMedicineMutation,
  useRemoveMultiMedicineMutation,
  useGetFavoritesMedicineQuery,
  useSendPrescriptionMutation,
  useOverridePrescriptionMutation,
  useSendPrintPrescriptionMutation,
  useDeletePrescriptionMutation,
  useCheckDublicatePrescriptionMutation,
  useChangePharmacyMutation,
  useDeleteMedicationMutation,
  useGetIndexLogMutation,
  useGetInterventionMutation,
  useGetUpdatePrescriberMutation,
  useFetchCategoryByWordQuery,
  useActivateMedicationMutation,
  useDelFavMedicationMutation,
  UseErxProcessMedicationMutation,
  useGetSurescriptsHistoryMutation,
  useEpcPrescriptionMutation,
  useEpcAgreementSaveMutation,
  useCalculateDoseMedicationMutation,
  useDeleteRefusalMedMutation,
  useActivateBulkMedMutation,
  useGetMedicationHistoryQuery,
  useUpdateFavMedicationMutation,
  useAddToGDRMutation,
  useGetGdrMedicationQuery,
  useSaveGDRMutation,
  useRemoveGDRMutation,
  useGetAddHistoryDataMutation,
  useGetPrescriberDetailForPatientQuery
} = medicationApi;

export function findMedicine(inputValue, is_dispensing_med = 0) {
  return axios.get(
    `${getBaseUrl()}/prescriptions/ds_search_medicine.json?keyword=${inputValue}${is_dispensing_med ? "&is_dispensing_med=1" : ""
    }`
  );
}


export function findMedicineStreangth(payload) {
  payload.medicine = encodeURIComponent(payload.medicine);
  //payload.medicine = payload.medicine;

  payload.strength = JSON.stringify(payload.strength);
  return axios.post(
    `${getBaseUrl()}/prescriptions/ds_search_strength.json?pid=${payload.pid}`,
    payload
  );
}

export function fetchPharmacy(payload) {
  return axios.post(
    `${getBaseUrl()}/prescriptions/get_frequently_used_pharmacies.json.json`,
    payload
  );
}

export function loadMedciationActionsData(payload) {
  if (payload.pid){
  return axios.get(
    `${getBaseUrl()}/orders/get_medication_form_lists.json?drug_rcopia_id=${payload?.drug_rcopia_id ? payload?.drug_rcopia_id :"" }&pid=${payload?.pid}&med_id=${payload?.med_id ? payload?.med_id : ""}`
  );}
}
export function getMedAllergyInteractions(payload) {
  return axios.post(
    `${getBaseUrl()}/prescriptions/get_med_allergy_interactions.json`,
    payload
  );
}
export function getMedicationCoverageDetails(payload) {
  if (payload){
  return axios.get(
    `${getBaseUrl()}/prescriptions/ds_get_med_coverage_detailed.json?drug_rcopia_id=${payload.drug_rcopia_id}&pid=${payload.pid}&formulary=${payload.formulary}&patient_eligibility_id=${payload.patient_eligibility_id}&ds_patient_id=${payload.ds_patient_id}`
  );}
}

export function getMostUsedSigValues(ndc) {
  return axios.get(
    `${getBaseUrl()}/prescriptions/get_most_used_sig_values.json?ndc=${ndc}`
  );
}
export function getMedicationHistory(ndc,pid) {
  return axios.get(
    `${getBaseUrl()}/prescriptions/get_med_history.json?ndc=${ndc}&pid=${pid}`
  );
}
export function getSupervisorsList(provider_id,pid) {
  return axios.get(
    `${getBaseUrl()}/users/get_supervisors_list.json?provider_id=${provider_id}&pid=${pid}`
  );
}

